import { Injectable } from '@angular/core';
import { AppService } from '../app.service';
import { HttpClient } from '@angular/common/http';
import { UserModel } from '../models/user.model';

@Injectable()
export class DeleteAccountService extends AppService<UserModel> {

  constructor(http: HttpClient) {
    super(http);
  }

  async removeAccount() {
    const result = await this.putAsync('Account/Remove', {});
    return result;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/services/deleteAccount.service.ts